'use strict';

module.exports = {
  environment: 'staging'
};